import { Link } from "react-router";

function InstagramIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
      <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
    </svg>
  );
}

export default function Footer() {
  return (
    <footer className="w-full bg-[#111111] text-[#F3F3F1]">
      <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8 px-6 py-12 md:px-12 border-b border-white/10">
        <div>
          <h3 className="text-xl font-black tracking-tighter mb-4">Pickle</h3>
          <p className="text-xs font-mono text-gray-400 leading-relaxed">
            Advanced AI Photo Generation Studio.
            <br />
            Creating digital personas since 2024.
          </p>
        </div>
        <a
          href="https://www.instagram.com/pickle_salon/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-gray-400 hover:text-white transition-colors"
          aria-label="Instagram"
        >
          <InstagramIcon className="size-6" />
        </a>
      </div>
      <div className="px-6 py-6 md:px-12 border-b border-white/10">
        <div className="text-xs text-gray-500 space-y-1">
          <p>
            <span className="text-gray-400">상호:</span> 슬로우키니 |{" "}
            <span className="text-gray-400">대표:</span> 김채현
          </p>
          <p>
            <span className="text-gray-400">주소:</span> 경기도 광주시
            수레실길30, 401호
          </p>
          <p>
            <span className="text-gray-400">고객센터:</span> 010-5272-0220
          </p>
          <p>
            <span className="text-gray-400">사업자등록번호:</span> 146-52-00630
            | <span className="text-gray-400">통신판매업신고:</span>{" "}
            2022-서울서초-1240
          </p>
        </div>
        <div className="flex flex-wrap gap-4 mt-4 text-xs">
          <Link
            to="/legal/terms-of-service"
            className="text-gray-400 hover:text-white transition-colors"
          >
            이용약관
          </Link>
          <Link
            to="/legal/privacy-policy"
            className="text-gray-400 hover:text-white transition-colors"
          >
            개인정보처리방침
          </Link>
          <Link
            to="/legal/refund-policy"
            className="text-gray-400 hover:text-white transition-colors"
          >
            환불규정
          </Link>
        </div>
      </div>
      <div className="px-6 py-4 md:px-12 flex justify-between items-center text-[10px] font-mono text-gray-500 uppercase">
        <span>© {new Date().getFullYear()} 슬로우키니</span>
        <span>All Rights Reserved</span>
      </div>
    </footer>
  );
}
